import React from "react";
import { IUser } from "../types/IAuth";
import { IMessageType } from "../api/ChatService";
import { IRoom } from "../components/Sidebar/components/ChatRoom";

type State = {
  rooms: IRoom[] | any;
  messages: IMessageType | any;
  isLoadingMessage: boolean;
  roomSelected: IRoom | any;
};
export const CASE = {
  GET_ROOMS: "GET_ROOMS",
  GET_MESSAGES: "GET_MESSAGES",
  LOADING_MESSAGES: "LOADING_MESSAGES",
  SET_ROOM_SELECTED: "SET_ROOM_SELECTED",
};
type Action = {
  type: string;
  payload: any;
};

type Dispatch = (action: Action) => void;

const initialState: State = {
  rooms: [],
  roomSelected: null,
  messages: [],
  isLoadingMessage: false,
};

type ChatContextProviderProps = { children: React.ReactNode };

const ChatContext = React.createContext<
  { state: State; dispatch: Dispatch } | undefined
>(undefined);

const stateReducer = (state: State, action: Action) => {
  switch (action.type) {
    case CASE.GET_ROOMS: {
      return {
        ...state,
        rooms: action.payload,
      };
    }
    case CASE.SET_ROOM_SELECTED: {
      return {
        ...state,
        roomSelected: action.payload,
      };
    }
    case CASE.GET_MESSAGES: {
      return {
        ...state,
        messages: action.payload,
      };
    }
    case CASE.LOADING_MESSAGES: {
      return {
        ...state,
        isLoadingMessage: action.payload,
      };
    }

    default: {
      throw new Error(`Unhandled action type`);
    }
  }
};

const ChatContextProvider = ({ children }: ChatContextProviderProps) => {
  const [state, dispatch] = React.useReducer(stateReducer, initialState);

  const value = { state, dispatch };
  return <ChatContext.Provider value={value}>{children}</ChatContext.Provider>;
};

const useChatContext = () => {
  const context = React.useContext(ChatContext);

  if (context) {
    return context;
  }

  throw new Error(`useChatContext must be used within a ChatContextProvider`);
};

export { ChatContextProvider, useChatContext };
